import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';

import { useKeystoneSession } from '../../auth/use-keystone-session';

import { lang } from '@lang';
import { saveCustomerBlueprint } from '@external';
import { useAppToast, useDesign } from '@hooks';
import { selectNavigation, selectSetPushSubmissionDataModal, setPushSubmissionDataModal, useAppDispatch, useAppSelector } from '@state';
import { useEffect, useState, type JSX } from 'react';


export const PushSubmissionModal = (): JSX.Element => {
	const [controller] = useDesign();
	const { getToken } = useKeystoneSession();
	const appToast = useAppToast();

	const dispatch = useAppDispatch();
	const state = useAppSelector(selectSetPushSubmissionDataModal);
	const appNav = useAppSelector(selectNavigation);

	const [success, setSuccess] = useState<string | null>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (controller && success !== null) {
			appToast.success({ title: lang.customer.message.pushSubmissionSuccess });
		}
	}, [success]);

	useEffect(() => {
		if (error !== null) {
			appToast.error({ title: lang.customer.message.pushSubmissionFailed });
		}
	}, [error]);

	const onClose = () => {
		dispatch(setPushSubmissionDataModal(false));
	};

	const handlePushSubmission = () => {
		if (controller && appNav.email) {
			saveCustomerBlueprint({
				controller,
				customerEmail: appNav.email,
				mode: 'test',
				getToken,
				setSuccess,
				setError
			});

			dispatch(setPushSubmissionDataModal(false));
		}
	};

	return (
		<Modal isOpen={state.isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalCloseButton />
				<>
					<ModalHeader>Warning</ModalHeader>
					<ModalBody>
						<Text>{lang.customer.message.pushSubmission}</Text>
					</ModalBody>

					<ModalFooter>
						<Button variant="ghost" mr={3} onClick={onClose}>Cancel</Button>
						<Button colorScheme="green" onClick={handlePushSubmission}>Continue</Button>
					</ModalFooter>
				</>
			</ModalContent>
		</Modal>
	);
};
